export function pauseAllYoutubeVideos() {
  const containerElement = document.getElementById('product-images');
  if (containerElement) {
    // TODO: refactor, delete iframe_tag
    const iframe_tag = containerElement.querySelector('iframe');
    const video_tag = containerElement.querySelector('video');
    if (iframe_tag) {
      const iframeSrc = iframe_tag.src;
      iframe_tag.src = iframeSrc;
    }
    if (video_tag) {
      video_tag.pause();
    }
  }
}
